
import React from "react";

const contactCards = [
  {
    icon: "ri-phone-line",
    title: "Call Us",
    lines: ["+1 (909) 257-7510", "Mon – Fri, 8:00 AM – 6:00 PM EST"],
  },
  {
    icon: "ri-mail-line",
    title: "Email Us",
    lines: ["adam@patriotdt.com"],
  },
];

export default function ContactInfo() {
  // Gracefully handle unexpected data structures
  const safeContactCards = Array.isArray(contactCards) ? contactCards : [];

  return (
    <div className="flex flex-col gap-5">
      {safeContactCards.map((card, idx) => (
        <div
          key={idx}
          className="bg-white border border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
        >
          <div className="w-11 h-11 rounded-lg bg-[#0066CC]/10 flex items-center justify-center mb-4">
            <i className={`${card.icon} text-xl text-[#0066CC]`}></i>
          </div>
          <h3 className="text-sm font-semibold text-gray-900 mb-2">{card.title}</h3>
          {Array.isArray(card.lines) &&
            card.lines.map((line, i) => (
              <p key={i} className="text-sm text-gray-500 leading-relaxed">
                {line}
              </p>
            ))}
        </div>
      ))}

      {/* Social Links */}
      <div className="bg-white border border-gray-100 rounded-xl p-6 shadow-sm">
        <h3 className="text-sm font-semibold text-gray-900 mb-4">
          Connect With Us
        </h3>
        <div className="flex items-center gap-3">
          {[
            { icon: "ri-linkedin-fill", label: "LinkedIn", href: "#" },
            { icon: "ri-twitter-x-fill", label: "Twitter", href: "#" },
            { icon: "ri-facebook-fill", label: "Facebook", href: "#" },
            { icon: "ri-youtube-fill", label: "YouTube", href: "#" },
          ].map((s, i) => (
            <a
              key={i}
              href={s.href}
              rel="nofollow"
              aria-label={s.label}
              onClick={(e) => {
                // Prevent navigation when href is a placeholder
                if (s.href === "#") e.preventDefault();
              }}
              className="w-10 h-10 rounded-lg bg-gray-50 border border-gray-100 flex items-center justify-center text-gray-500 hover:bg-[#0066CC] hover:text-white hover:border-[#0066CC] transition-all cursor-pointer"
            >
              <i className={`${s.icon} text-lg`}></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
